import { IconSpinner } from "@/assets/icons/geist/IconSpinner";
import { SearchInput } from "@/components/flexkit/SearchInput";
import type { FC, InputHTMLAttributes } from "react";

type ProjectSearchInputProps = {
    searchValue?: string;
    isLoading?: boolean;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
} & InputHTMLAttributes<HTMLInputElement>;
export const ProjectSearchInput: FC<ProjectSearchInputProps> = ({
    searchValue,
    isLoading,
    disabled,
    setSearchValue,
    ...props
}) => {
    return (
        <div className="relative flex w-full">
            <span className="sr-only">Search projects</span>
            {isLoading && <IconSpinner className="absolute right-[12px] top-[10px] z-20 animate-spin text-content-tertiary" size="sm" />}
            <SearchInput
                wrapperClassName="w-full"
                className="max-w-none"
                placeholder="Search projects"
                value={searchValue || ""}
                onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
                onClear={() => setSearchValue("")}
                disabled={disabled}
                {...props}
            />
        </div>
    );
};
